import { useEffect } from 'react';
import { getVideoTime } from '~/utils/video-tools/getVideoTime';
import useCustomAnalytics from './use-custom-analytics';

// Track using mux player and videoJS
const useMuxVideoAnalytics = ({ playerRef, id, locationDetail, title, seek = true, pause = true, play = true }) => {
  const { trackVideoPlay, trackVideoPause, trackVideoSeek } = useCustomAnalytics();
  useEffect(() => {
    if (!playerRef.current) return;
    const video = playerRef.current;
    if (play) {
      video.on('play', () => {
        trackVideoPlay({
          id,
          title,
          locationDetail,
        });
      });
    }

    if (pause) {
      video.on('pause',
        () => trackVideoPause({ id, title, locationDetail, time: getVideoTime(video, true) }))
    }

    if (seek) {
      video.on('seeked',
        () => trackVideoSeek({ id, title, locationDetail, time: getVideoTime(video, true) }))
    }

    return () => {
      if (play) { video.off('play', () => trackVideoPlay({ id, title, locationDetail, time: getVideoTime(video, true) })); }
      if (pause) {
        video.off('pause',
          () => trackVideoPause({ id, title, locationDetail, time: getVideoTime(video, true) })
        );
      }
      if (seek) {
        video.off('seeked',
          () => trackVideoSeek({ id, title, locationDetail, time: getVideoTime(video, true) }));
      }
    };
  }, [playerRef]);
};

export default useMuxVideoAnalytics;
